<template>
  <div class="footer">
    <div class="footer-message">
      Want to see more data?
    </div>
    <PrimaryButton @click="createReport">
      Create Report
    </PrimaryButton>
  </div>
</template>

<script>
import { PrimaryButton } from '@mikmak/components';
import eventDispatcher from '../../../events/dispatch';

export default {
  components: {
    PrimaryButton,
  },
  methods: {
    createReport() {
      this.$store.commit('resetExplorerReport');
      this.$store.dispatch('setDashboardSelectedFilters', []);
      this.$router.push({ name: 'explorer-base' });
      this.scrollAndDispatch();
    },
    scrollAndDispatch() {
      window.scrollTo(0, 0);
      eventDispatcher('createReportFooterButtonClicked');
    },
  },
};
</script>

<style lang='scss' scoped>
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-bottom: 48px;

  .footer-message {
    font-weight: 400;
    font-size: 16px;
    line-height: 22.4px;
    color: #778699;
  }
}
</style>
